import { render, staticRenderFns } from "./settingTableTransfer.vue?vue&type=template&id=06dd0b1c&scoped=true&"
import script from "./settingTableTransfer.vue?vue&type=script&lang=ts&"
export * from "./settingTableTransfer.vue?vue&type=script&lang=ts&"
import style0 from "./settingTableTransfer.vue?vue&type=style&index=0&id=06dd0b1c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06dd0b1c",
  null
  
)

export default component.exports